import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";

export default function VentasMovil() {
  const [user, setUser] = useState(null);

  // 🔁 Cambiado: orden -> id_generico
  const [filtros, setFiltros] = useState({
    id_generico: "",
    ejecutivo: "",
    supervisor: "",
    periodo: "",
  });

  const [filtrando, setFiltrando] = useState(false);
  const [transacciones, setTransacciones] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);

  // 🔁 Cambiado: ordenSeleccionada -> idGenericoSeleccionado
  const [detalleHTML, setDetalleHTML] = useState("");
  const [idGenericoSeleccionado, setIdGenericoSeleccionado] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } else {
      window.location.href = "/login";
      return;
    }
  }, []);

  useEffect(() => {
    cargarTransacciones();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginaActual]);

  const token = () => localStorage.getItem("token");

  const cargarTransacciones = () => {
    setFiltrando(true);
    axios
      .get("https://api.t-sales.cl/api/transacciones-moviles", {
        params: { ...filtros, page: paginaActual },
        headers: { Authorization: `Bearer ${token()}` },
      })
      .then((res) => {
        setTransacciones(res.data.data || []);
        setTotalPaginas(res.data.last_page || 1);
      })
      .catch((err) => console.error("Error al cargar transacciones móviles:", err))
      .finally(() => setFiltrando(false));
  };

  const cambiarPagina = (nuevaPagina) => {
    if (nuevaPagina >= 1 && nuevaPagina <= totalPaginas) {
      setPaginaActual(nuevaPagina);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  const handleChangeFiltro = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmitFiltros = (e) => {
    e.preventDefault();
    setPaginaActual(1);
    cargarTransacciones();
  };

  // 🔁 Cambiado: reset con id_generico
  const handleResetFiltros = () => {
    setFiltros({ id_generico: "", ejecutivo: "", supervisor: "", periodo: "" });
    setPaginaActual(1);
    cargarTransacciones();
  };

  // 🔁 Cambiado: export con id_generico
  const handleExportar = () => {
    const query = new URLSearchParams({ ...filtros, export: 1 }).toString();
    window.open(`https://api.t-sales.cl/api/transacciones-moviles/export?${query}`, "_blank");
  };

  // 🔁 Cambiado: abre por id_generico y llama a /transacciones-moviles/{id_generico}
  const abrirModalDetalle = (id_generico) => {
    setIdGenericoSeleccionado(id_generico);
    setDetalleHTML("Cargando...");
    axios
      .get(`https://api.t-sales.cl/api/transacciones-moviles/${encodeURIComponent(id_generico)}`, {
        headers: { Authorization: `Bearer ${token()}` },
      })
      .then((res) => setDetalleHTML(res.data))
      .catch(() => setDetalleHTML("<p class='text-red-600'>Error al cargar detalle.</p>"));
  };

  const cerrarModalDetalle = () => {
    setIdGenericoSeleccionado(null);
    setDetalleHTML("");
  };

  function ModalCargarVentasMovil({ visible, onClose }) {
    const [archivo, setArchivo] = useState(null);
    const [mensaje, setMensaje] = useState("");
    const [subiendo, setSubiendo] = useState(false);

    const token = () => localStorage.getItem("token");

    const handleFileChange = (e) => {
      setArchivo(e.target.files[0]);
    };

    const handleUpload = () => {
      if (!archivo) return alert("Selecciona un archivo .xlsx primero.");

      setSubiendo(true);
      const formData = new FormData();
      formData.append("archivo", archivo);

      axios
        .post("https://api.t-sales.cl/api/transacciones-moviles/cargar", formData, {
          headers: {
            Authorization: `Bearer ${token()}`,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => setMensaje("✅ Archivo cargado correctamente."))
        .catch(() => setMensaje("❌ Error al subir el archivo."))
        .finally(() => setSubiendo(false));
    };

    if (!visible) return null;

    return (
      <AnimatePresence>
        <motion.div
          className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 px-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white text-[#0F1C17] rounded-xl shadow-2xl w-full max-w-md p-6 relative"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
          >
            <button
              onClick={onClose}
              className="absolute top-3 right-3 text-gray-600 text-2xl"
            >
              &times;
            </button>
            <h2 className="text-xl font-bold mb-4">📤 Cargar Ventas Móvil</h2>

            <input type="file" accept=".xlsx" onChange={handleFileChange} className="mb-4" />

            <div className="flex justify-between items-center gap-4">
              <button
                onClick={handleUpload}
                disabled={subiendo}
                className="bg-[#006f91] text-white px-4 py-2 rounded-xl w-full mt-3"
              >
                {subiendo ? "Subiendo..." : "Subir archivo"}
              </button>
            </div>

            {mensaje && <p className="mt-4 text-sm text-center">{mensaje}</p>}
          </motion.div>
        </motion.div>
      </AnimatePresence>
    );
  }

  return (
    <div className="min-h-screen bg-[#006f91] text-white px-4 py-8 flex flex-col">
      {/* HEADER */}
      <header className="max-w-6xl w-full mx-auto flex items-center justify-between mb-10">
        <h1 className="text-3xl font-bold">Listado Ventas Móvil</h1>
        <button
          onClick={handleLogout}
          className="bg-[#64FFDA] hover:bg-[#1DE9B6] text-[#0F1C17] font-semibold px-4 py-2 rounded-xl transition-all"
        >
          Cerrar sesión
        </button>
      </header>

      {/* FILTROS */}
      <section className="max-w-6xl w-full mx-auto bg-white/10 backdrop-blur-md p-6 rounded-xl border border-white/10 mb-6">
        <form onSubmit={handleSubmitFiltros} className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {/* 🔁 Cambiado a ID_GENÉRICO */}
          <input
            type="text"
            name="id_generico"
            placeholder="Buscar por ID genérico"
            value={filtros.id_generico}
            onChange={handleChangeFiltro}
            className="bg-white/90 text-[#0F1C17] rounded px-3 py-2 placeholder-gray-500 focus:outline-none"
          />
          <input
            type="text"
            name="ejecutivo"
            placeholder="Buscar por ejecutivo"
            value={filtros.ejecutivo}
            onChange={handleChangeFiltro}
            className="bg-white/90 text-[#0F1C17] rounded px-3 py-2 placeholder-gray-500 focus:outline-none"
          />
          <input
            type="text"
            name="supervisor"
            placeholder="Buscar por supervisor"
            value={filtros.supervisor}
            onChange={handleChangeFiltro}
            className="bg-white/90 text-[#0F1C17] rounded px-3 py-2 placeholder-gray-500 focus:outline-none"
          />
          <input
            type="text"
            name="periodo"
            placeholder="Buscar por periodo"
            value={filtros.periodo}
            onChange={handleChangeFiltro}
            className="bg-white/90 text-[#0F1C17] rounded px-3 py-2 placeholder-gray-500 focus:outline-none"
          />

          <div className="md:col-span-4 flex flex-wrap items-center justify-center gap-4 pt-2">
            <button
              type="submit"
              className="bg-[#64FFDA] hover:bg-[#1DE9B6] text-[#0F1C17] font-semibold px-4 py-2 rounded-xl transition-all"
            >
              Filtrar
            </button>
            <button
              type="button"
              onClick={handleResetFiltros}
              className="text-white/80 underline underline-offset-4 hover:text-white"
            >
              Reiniciar filtros
            </button>
            <button
              type="button"
              onClick={handleExportar}
              className="bg-green-500 hover:bg-green-400 text-white font-semibold px-4 py-2 rounded-xl transition-all flex items-center gap-2"
            >
              <span role="img" aria-label="descargar">📥</span> Exportar Excel
            </button>
            <button
              type="button"
              onClick={() => setModalVisible(true)}
              className="bg-yellow-400 hover:bg-yellow-300 text-black font-semibold px-4 py-2 rounded-xl transition-all flex items-center gap-2"
            >
              📤 Cargar Ventas Móvil
            </button>
          </div>
        </form>
      </section>

      {/* TABLA */}
      <section className="max-w-6xl w-full mx-auto flex-1 overflow-hidden">
        <div className="overflow-x-auto h-full bg-white/10 backdrop-blur-md rounded-xl border border-white/10">
          <table className="min-w-full text-sm text-left text-white">
            <thead className="text-xs uppercase text-white/90 bg-white/5 sticky top-0 z-10">
              <tr>
                {["ID Genérico", "Periodo", "Cliente", "Producto", "Celular", "Ejecutivo", "Supervisor"].map((th) => (
                  <th key={th} className="px-4 py-3 font-semibold whitespace-nowrap">{th}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtrando ? (
                <tr><td colSpan={7} className="text-center py-10">Cargando datos...</td></tr>
              ) : transacciones.length === 0 ? (
                <tr><td colSpan={7} className="text-center py-10">No se encontraron registros.</td></tr>
              ) : (
                transacciones.map((row, i) => (
                  <tr
                    key={row.id_generico ?? row.orden ?? i}
                    onClick={() => abrirModalDetalle(row.id_generico)}
                    className="border-t border-white/10 hover:bg-white/5 cursor-pointer transition-colors"
                  >
                    <td className="px-4 py-2 whitespace-nowrap">{row.id_generico || "—"}</td>
                    <td className="px-4 py-2 whitespace-nowrap">{row.periodo}</td>
                    <td className="px-4 py-2 whitespace-nowrap">{row.cliente}</td>
                    <td className="px-4 py-2 whitespace-nowrap">{row.producto}</td>
                    <td className="px-4 py-2 whitespace-nowrap">{row.celular}</td>
                    <td className="px-4 py-2 whitespace-nowrap">{row.ejecutivo}</td>
                    <td className="px-4 py-2 whitespace-nowrap">{row.supervisor}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </section>

      {/* PAGINACIÓN */}
      {!filtrando && totalPaginas > 1 && (
        <div className="flex justify-center items-center gap-4 p-4 text-white">
          <button
            onClick={() => cambiarPagina(paginaActual - 1)}
            disabled={paginaActual === 1}
            className="px-4 py-2 rounded bg-white/20 hover:bg-white/30 disabled:opacity-50"
          >
            ← Anterior
          </button>
          <span>Página {paginaActual} de {totalPaginas}</span>
          <button
            onClick={() => cambiarPagina(paginaActual + 1)}
            disabled={paginaActual === totalPaginas}
            className="px-4 py-2 rounded bg-white/20 hover:bg-white/30 disabled:opacity-50"
          >
            Siguiente →
          </button>
        </div>
      )}

      {/* MODAL DETALLE */}
      <AnimatePresence>
        {idGenericoSeleccionado && (
          <motion.div
            className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 px-4"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-white text-[#0F1C17] rounded-xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col relative"
              initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.8, opacity: 0 }}
              transition={{ type: "spring", stiffness: 260, damping: 20 }}
            >
              <button
                onClick={cerrarModalDetalle}
                className="absolute top-3 right-3 text-gray-600 hover:text-black text-2xl leading-none"
              >
                &times;
              </button>
              <header className="px-6 pt-6 pb-4 border-b border-gray-200 flex items-center gap-2 text-xl font-bold">
                📄 Detalle Transacción Móvil – ID: {idGenericoSeleccionado}
              </header>
              <section
                className="px-6 py-4 overflow-y-auto text-sm flex-1"
                dangerouslySetInnerHTML={{ __html: detalleHTML }}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <ModalCargarVentasMovil visible={modalVisible} onClose={() => setModalVisible(false)} />
    </div>
  );
}
